import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';
import type { RecognitionRunKind } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const useRerunRecognitionMutation = () =>
  useMutation({
    mutationFn: ({ url, kind }: { url: string; kind: RecognitionRunKind }) =>
      HttpClient.request<MutationResponse>({
        method: 'POST',
        url,
        data: { kind },
      }),
  });
